// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"32":"9dcb7d11","576":"9be079dd","870":"38e60213","915":"040abc46"}[chunkId] + ".chunk.css";
};